var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconVoucher = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21.75 13.5C20.8312 13.5 20.25 12.8348 20.25 12C20.25 11.1652 20.8312 10.5 21.75 10.5C22.164 10.5 22.5 10.164 22.5 9.75V5.25C22.5 4.836 22.164 4.5 21.75 4.5H2.25C1.836 4.5 1.5 4.836 1.5 5.25V9.75C1.5 10.164 1.836 10.5 2.25 10.5C3.16875 10.5 3.75 11.1652 3.75 12C3.75 12.8348 3.16875 13.5 2.25 13.5C1.836 13.5 1.5 13.836 1.5 14.25V18.75C1.5 19.164 1.836 19.5 2.25 19.5H21.75C22.164 19.5 22.5 19.164 22.5 18.75V14.25C22.5 13.836 22.164 13.5 21.75 13.5ZM21 9.0855C19.6268 9.4095 18.75 10.6163 18.75 12C18.75 13.3837 19.6268 14.5905 21 14.9145V18H3V14.9145C4.37325 14.5905 5.25 13.3837 5.25 12C5.25 10.6163 4.37325 9.4095 3 9.0855V6H21V9.0855Z", fill: "black" }))),
        alt: 'Voucher',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconVoucher;
//# sourceMappingURL=index.js.map